import axiosClient from "../../../../system/helpers/axiosConfig";

export const postChatMessage = (params) => {
  return axiosClient
    .post(`/api/im/view/${params.id}`, params)
    .then((r) => r.data);
};
